<template>
  <div id="RanksByGroup">
    <div class="row">
        <div class="chart-segment-options col-3">
            <modal-link modal-id="Ranks By Group Options" :content-list="pageContent"></modal-link>
            <a href="#!" v-show="!displayRanksByGroup" @click="toggleRanksByGroup">Show Ranks by Group<i class="fa fa-chevron-down ml-1"></i></a>
            <a href="#!" v-show="displayRanksByGroup" @click="toggleRanksByGroup">Hide Ranks by Group<i class="fa fa-chevron-up ml-1"></i></a>
        </div>
        <div v-show="displayRanksByGroup" class="col-9 pt-3 pb-3">
            <div class="form-row">  
                <div class="chart-criteria-section-1">   
                    <div class="chart-criteria-row">
                        <div class="chart-criteria-label-column">
                            <label for="period" class="sub-heading-label">Period</label>
                        </div>
                        <div class="chart-criteria-field-column">
                            <select
                                id="period"
                                name="period"
                                class="custom-select required shadow w-100 col-12"
                                v-model="period"
                            >
                                <option value="">Select</option>
                                <option v-for="(option, idxPeriodOptions) in client_time_periods" v-bind:value="option.clientTimePeriodId" v-bind:key="idxPeriodOptions">
                                {{ option.displayName }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="chart-criteria-row">
                        <div class="chart-criteria-label-column"></div>
                        <div class="chart-criteria-field-column">
                            <div class="form-group">
                                <input
                                    id="useTTMAsStartDate"
                                    name="useTTMAsStartDate"
                                    type="checkbox"
                                    true-value="Y"
                                    false-value="N"
                                    v-model="useTTMAsStartDate"
                                />
                                <span class="ml-1 mr-1">Use TTM as Data Start Date</span>
                        </div>                
                        <div class="form-group">
                            <input
                                id="customTimePeriod"
                                name="customTimePeriod"
                                type="checkbox"
                                true-value="Y"
                                false-value="N"
                                v-model="customTimePeriod"
                            />
                            <span class="ml-1 mr-1">Custom Time Period</span>
                            <div v-show="displayCustomDateFields" class="chart-criteria-row w-100">
                                <div class="chart-criteria-label-column">
                                    <label for="customStartDate" class="sub-heading-label">Start Date</label>
                                </div>
                                <datepicker format="MMM dd yyyy" v-model="customStartDate" :typeable="true" wrapper-class="" input-class="form-control required w-100 bg-white" name="customStartDate"></datepicker>
                            </div>
                            <div v-show="displayCustomDateFields" class="chart-criteria-row w-100">
                                <div class="chart-criteria-label-column">
                                  <label for="customEndDate" class="sub-heading-label">End Date</label>
                                </div>
                                <datepicker format="MMM dd yyyy" v-model="customEndDate" :typeable="true" wrapper-class="" input-class="form-control required w-100 bg-white" name="customEndDate"></datepicker>
                            </div>
                        </div>
                        <div class="form-group">
                            <input
                                id="includePartialResponses"
                                name="includePartialResponses"
                                type="checkbox"
                                true-value="Y"
                                false-value="N"
                                v-model="includePartialResponses"
                            />
                            <span class="ml-1 mr-1">Include Partial Responses</span>
                        </div>
                        </div>
                    </div>                  
                </div>    
                <div class="chart-criteria-section-2">   
                    <div class="chart-criteria-row">
                        <div class="chart-criteria-label-column">
                            <label for="surveyGroupForRanksByGroup" class="sub-heading-label">Use Group <br> for Ranks</label>
                        </div>
                        <div class="chart-criteria-field-column">
                        <select
                            id="surveyGroupForRanksByGroup"
                            name="surveyGroupForRanksByGroup"
                            class="custom-select shadow w-100"
                            v-model="surveyGroupForRanksByGroup"
                        >
                            <option value="">None</option>
                            <option v-for="(option, idxSurveyGroupOptions) in survey_group_options_for_ranks_by_group" v-bind:value="option.value" v-bind:key="idxSurveyGroupOptions">
                            {{ option.name }}
                            </option>
                        </select>
                        </div>
                    </div>
                    <div class="chart-criteria-row">
                        <div class="chart-criteria-label-column"></div>
                        <div class="chart-criteria-field-column">
                            <div class="form-group">
                                <input 
                                    id="showPublicGroupsForRanksByGroup" 
                                    name="showPublicGroupsForRanksByGroup" 
                                    type="checkbox" 
                                    true-value="Y" 
                                    false-value="N" 
                                    v-model="showPublicGroupsForRanksByGroup" 
                                    @click="saveCheckboxValue($event, 'Show Public Groups', 'show_public_groups', true)"
                                    />
                                <span class="ml-1 mr-1">Show Public Groups</span>
                            </div>                  
                            <div class="form-group">
                                <input
                                    id="includeOrganizationSelectedInGroupRanks"
                                    name="includeOrganizationSelectedInGroupRanks"
                                    type="checkbox"
                                    true-value="Y"
                                    false-value="N"
                                    v-model="includeOrganizationSelectedInGroupRanks"
                                    v-on:change="setIncludeOrganizationSelectedInGroupRanks();"
                                />
                                <span class="ml-1">Include Organization in Group Ranks</span>
                            </div>
                        </div>
                    </div>
                </div>    
                <div class="chart-criteria-section-3">   
                    <div class="chart-criteria-row">
                        <div class="chart-criteria-label-column">
                            <label class="sub-heading-label"># of Ranking Tiers</label>
                        </div>
                    <div class="chart-criteria-field-column">
                        <select
                        id="ranking_tier"
                        name="ranking_tier"
                        class="custom-select shadow w-100"
                        v-model="ranking_tier"
                        >
                        <option value="">Select</option>
                        <option v-for="(option, idxRankingTiersOptions) in number_of_ranking_tiers_options" v-bind:value="option.value" v-bind:key="idxRankingTiersOptions">
                            {{ option.name }}
                        </option>
                        </select>
                    </div>
                    </div>
                </div>    
            </div>            
            <div class="form-row">
                <button class="btn btn-primary float-right ml-2" @click="processRankByGroup">
                    <span>Rank By Group</span>
                    <span v-show="this.$root.getLoading()" class="spinner-border spinner-border-sm"></span>
                </button>    
                <button class="btn btn-primary float-right ml-2" @click="setDefaultValues">
                    <span>Reset</span>
                </button>    
            </div>        
        </div>        
    </div>            
    <div v-show="displayRanksByGroup" id="chart-container" class="row w-100">
        <div class="col-12">
            <chart-display-skeleton v-show="generatingTable"/>
            <div v-show="$parent.getDisplayView() && getDisplayView()" id="base-rank-data-container" class="chart-data">
              <chart-data-table
                  v-show="$parent.getDisplayView() && getDisplayView() && displayRankings"
                  ref="baseRankDataTable"
                  :data-container-id="'base-rank-data-container'"
                  :container-id="'base-rank'"
                  :report-page-type-name="'Table - Base Rank'"
                  :is-saved-card="false" 
                  :insight-modal-id="'base-rank-table'"
                  :chart-data="this.table.data"
                  v-bind:row-start-position="6"
                  :column-defs="columnDefs"
                  :use-alternate-title="false"
                  :table-class="'table display row-border table-hover'"
                  :table-width="'auto'"
                  :table-title="this.table.title"
                  :is-insider-user="this.$parent.isInsiderUser"
                  :inputDownloadFileName="this.chartTypeTitle"
              ></chart-data-table>
            </div>
        </div>
        <div v-show="$parent.getDisplayView() && getDisplayView() && !displayRankings" class="chart-data">There is not enough data for rankings</div>  
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ChartDataTable from "../../components/chart/ChartDataTable.vue";
import ContentMixins from "../../mixins/ContentMixins.vue";
import ViewMixins from "../../mixins/ViewMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import ChartCriteriaMixins from "../../mixins/ChartCriteriaMixins.vue";
import authHeader from "../../services/auth-header";
import SurveyService from "../../services/survey.service";
import ErrorService from "../../services/error.service";
import UserService from "../../services/user.service";
import SurveyGroupService from "../../services/survey.group.service";
import AdminService from "../../services/admin.service";
import GoogleService from "../../services/google.service";
import ClientTimePeriodService from "../../services/client.time.period.service";
import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import Datepicker from "vuejs-datepicker";



export default {
  name: "RanksByGroup",
  mixins: [ContentMixins,ViewMixins, DataTableMixins, ChartCriteriaMixins],
  components: {ChartDataTable, ChartDisplaySkeleton, Datepicker},
  data() {
    return {
        clientId: 0,
        client_time_periods: [],
        number_of_ranking_tiers_options: [
            {"name": "1","value": "1"},
            {"name": "2","value": "2"},
            {"name": "3","value": "3"},
            {"name": "4","value": "4"},
            {"name": "5","value": "5"},
            {"name": "10","value": "10"}
        ],  
        columnDefs: [],  
        surveyGroupForRanksByGroup: "",
        includeOrganizationSelectedInGroupRanks: "Y",
        showPublicGroupsForRanksByGroup: "Y",
        surveyGroupListForRanksByGroup: [],
        titleSuffix: "",
        displayType: "",
        displayRanksByGroup: false,
        generatingTable: false,
        isSavedCard: false,
        survey_group_options_for_ranks_by_group: [],
    };
  },
  props: {
    entrySurveyCode: {
      type: String,
      default: SurveyService.getSurveyCode()
    },
    surveyGroupOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    clientChart: {
      type: Object,
      default: function() {
        return {};
      }
    },    
    clientObject: {
      type: Object,
      default: function() {
        return {};
      }
    },
    autoGenerateRanksByGroup: {
      type: Boolean,
      default: false
    },

  },
  computed: {
    chartTypeTitle() {
      const chartType = this.$parent.$data.criteriaResultsList.find(item => item.name === "Performance");
      let chartTile = chartType ? `${chartType.displayValue} Rank` : "Base Rank";
      if (this.titleSuffix != null && this.titleSuffix != ""){
        chartTile += " - " + this.titleSuffix;
      }
      return chartTile;
    }
  },
  mounted() {
    this.loadData();
  },
  created() {},
  methods: {
    resetForm() {
      this.setDefaultValues();
      this.displayRanksByGroup = false;
    },
    resetValues() {
      this.setDisplayView(false);
      this.setDefaultValues();
    },
    toggleRanksByGroup() {
      let label = this.displayRanksByGroup ? "close" : "open";
      GoogleService.logClickEvent("Ranks By Group Section Toggle", label, 0, this);         

      this.displayRanksByGroup = !this.displayRanksByGroup;
    },
    setDefaultValues() {
      this.includePartialResponses = "Y";
      this.useTTMAsStartDate = "Y";
      this.customTimePeriod = false;
      this.customStartDate = new Date().toLocaleDateString("en-US");
      this.customEndDate = new Date().toLocaleDateString("en-US");
      this.surveyGroupForRanksByGroup =  "";
      this.includeOrganizationSelectedInGroupRanks = "Y";
      this.showPublicGroupsForRanksByGroup = "Y";
      this.ranking_tier = "";
      this.period = "";
    },
    async loadData() {
      this.resetForm();
      await ClientTimePeriodService.getClientTimePeriodsBySurveyCode(this.entrySurveyCode, this.getClientTimePeriodsBySurveyCodeCallback, this);
      if (!this.autoGenerateRanksByGroup){
        this.displayType = this.$parent.$data.displayType;
      }
    },
    getClientTimePeriodsBySurveyCodeCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.client_time_periods = response.data.data.clientTimePeriods;
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },    
    processRankByGroupCallback:function(response){
        // if the array is empty, then there is no data to show
        if (response.data.length == 0){
          this.generatingTable = false;
          this.$root.processServerResponse();
          AdminService.displayErrorMessage({ text: "There is no data available for the selected criteria." });
          return;
        }
        let returnData = JSON.parse(JSON.stringify(response.data[0]));
        let containerId = returnData["containerId"];
        let columns = returnData["cols"];
        let rows = returnData["rows"];
        this.table.id = containerId;
        this.columnDefs = this.buildColumnsForRanks(columns);        
        let otherData = returnData["otherData"];
        let titleSuffix = otherData["titleSuffix"];
        if (typeof titleSuffix != "undefined" && titleSuffix != null && titleSuffix != "") {
          this.titleSuffix = titleSuffix;
        }
        if (typeof otherData["tableTitle"] != "undefined"){
          this.table.title = otherData["tableTitle"];
        } else {
          this.table.title = "Rank";
        }
        this.table.data = returnData;
        if (rows.length == 1){
          this.displayRankings = false;
        } else { 
          this.displayRankings = true;
        }
        this.saveToCard();
        this.setDisplayView(true);
        this.generatingTable = false;
        this.$root.processServerResponse();
    },
    saveToCard: function(){
      // No action needed for Ranks By Group
        let params = new URLSearchParams();

        params.append("ranks_by_group_display_type", this.displayType);
        params.append("ranks_by_group_show_public_groups", this.showPublicGroupsForRanksByGroup);
        params.append("ranks_by_group_period", this.period);
        params.append("ranks_by_group_survey_group", this.surveyGroupForRanksByGroup);
        params.append("ranks_by_group_use_ttm_as_start_date", this.useTTMAsStartDate);
        params.append("ranks_by_group_include_partial_responses", this.includePartialResponses);  
        params.append("include_organization_selected_in_group_ranks", this.includeOrganizationSelectedInGroupRanks);
        params.append("ranks_by_group_ranking_tier", this.ranking_tier);
        params.append("auto_process_ranks_by_group", true);
        params.append("custom_start_date", this.customStartDate);
        params.append("custom_end_date", this.customEndDate);
        this.$emit("save-ranks-by-group-criteria", params);
    },    
    getSurveyGroupOptions: function(){
      return SurveyGroupService.getSurveyGroupOptions(this.surveyGroupListForRanksByGroup,this.showPublicGroupsForRanksByGroup,this.clientId);
    },    
    loadCriteriaData() {
      let params = new URLSearchParams(this.clientChart.criteria);
      let auto_process_ranks_by_group = params.get("auto_process_ranks_by_group") || false;
      if (auto_process_ranks_by_group== "true" || auto_process_ranks_by_group== true){
        const parseCriteriaDate = (criteriaValue) => {
          if (!criteriaValue) {
            return new Date().toLocaleDateString("en-US");
          }
          try {
            const dateString = decodeURIComponent(criteriaValue).replace(/\+/g, " ");
            const parsedDate = new Date(dateString);
            if (isNaN(parsedDate.getTime())) {
              return new Date().toLocaleDateString("en-US");
            }
            return parsedDate.toLocaleDateString("en-US");
          } catch (e) {
            return new Date().toLocaleDateString("en-US");
          }
        };
        
        this.period = params.get("ranks_by_group_period") || "";
        this.displayType = params.get("ranks_by_group_display_type") || "";
        this.useTTMAsStartDate = params.get("ranks_by_group_use_ttm_as_start_date") || "Y";
        this.includePartialResponses = params.get("ranks_by_group_include_partial_responses") || "Y";
        this.includeOrganizationSelectedInGroupRanks = params.get("include_organization_selected_in_group_ranks") || "Y";
        this.showPublicGroupsForRanksByGroup = params.get("ranks_by_group_show_public_groups") || "N";
        this.ranking_tier = params.get("ranks_by_group_ranking_tier") || "";
        this.customStartDate = parseCriteriaDate(params.get("custom_start_date"));
        this.customEndDate = parseCriteriaDate(params.get("custom_end_date"));
        this.displayRanksByGroup = true;
        this.isSavedCard = true;
        this.surveyGroupForRanksByGroup = params.get("ranks_by_group_survey_group") || "";
        this.processRankByGroup();
      }
    },
    processRankByGroup: async function(){
      this.generatingTable = true;
      if (this.period == "" || this.period == null || this.period == 0) {
        AdminService.displayErrorMessage({ text: "Please select a time period before downloading comments file." });
        this.generatingTable = false;
        return;
      }
      this.$root.processServerRequest("Processing Ranks By Group");
      let params = new URLSearchParams();  
      if (this.isSavedCard == false){
        this.displayType = this.$parent.$data.displayType;
      } else {
        this.isSavedCard = false;
      }
      params.append("client_id", this.clientObject.clientId);
      params.append("survey_id", SurveyService.getSurveyId());
      params.append("user_id", UserService.getUserId());
      params.append("period", this.period);

      params.append("include_partial_responses", this.includePartialResponses);
      params.append("use_ttm_as_data_start_date", this.useTTMAsStartDate);
      params.append("custom_time_period", this.customTimePeriod);
      params.append("display_type", this.displayType);
      params.append("survey_group", this.surveyGroupForRanksByGroup);
      params.append("include_organization_selected_in_group_ranks", this.includeOrganizationSelectedInGroupRanks);
      params.append("ranking_tier", this.ranking_tier);
      params.append("custom_start_date", this.customStartDate);
      params.append("custom_end_date", this.customEndDate);
      params = this.getSegments(params);
      let url = this.baseUrl + "/api/v1/chart/ranks"
      await axios
        .post(url, params, { headers: await authHeader() })
        .then(response => this.processRankByGroupCallback(response))
        .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("ChartSRanksByGroup.processRankByGroup", error, "chart", this);
      });
    },    
    getSegments(params){
      this.criteriaResults = JSON.parse(JSON.stringify(this.$parent.$refs.chartCriteria.$data.criteriaResults));
      let searchParams = new URLSearchParams();
      searchParams = this.buildCriteriaUrl(searchParams);
      let segments = searchParams.get("segments");
      if (typeof segments != "undefined" && segments != null && segments != "") {
         params.append("segments", segments);
      }
      return params
    },
    setIncludeOrganizationSelectedInGroupRanks: function() {
      
      if (this.includeOrganizationSelectedInGroupRanks == "N"){
        return;
      }
      if (this.surveyGroupForRanksByGroup.length != 0 || this.surveyGroupForRanksByGroup != ""){
        this.includeOrganizationSelectedInGroupRanks = "Y";
      } else {
        this.includeOrganizationSelectedInGroupRanks = "N";
      }
    },

  },
  watch: {
    clientChart: function() {
      if (this.clientChart != null && this.clientChart.clientChartId > 0 && this.autoGenerateRanksByGroup) {
        this.loadCriteriaData();
      }
    },
    showPublicGroupsForRanksByGroup: function() {
      this.survey_group_options_for_ranks_by_group = this.getSurveyGroupOptions();
      let surveyGroupOption = this.survey_group_options_for_ranks_by_group.find(x => x.value == this.surveyGroupForRanksByGroup);
      if (typeof surveyGroupOption == "undefined") {
        this.surveyGroupForRanksByGroup = "";
//        this.saveResultValue("", 'Survey Group', 'survey_group', true)
      }
    },    
    surveyGroupOptions: function(){
      this.surveyGroupListForRanksByGroup = JSON.parse(JSON.stringify(this.surveyGroupOptions));
      this.survey_group_options_for_ranks_by_group = this.getSurveyGroupOptions();
    },
    entrySurveyCode: function(newVal, oldVal) {
      this.loadData();
    },
    customTimePeriod: function() {
      if (this.customTimePeriod == true || this.customTimePeriod == "Y"){
        //this.saveResultValue(this.customStartDate, "Custom Start Date", "custom_start_date", true);
        //this.saveResultValue(this.customEndDate, "Custom End Date", "custom_end_date", true);
      } else {
        this.resetCustomFields();
      }
    },    

  }
};
</script>
